module.exports = __webpack_public_path__ + "static/img/bbl.54d441c3.svg";